import React from "react"
import Video from "../../video/Video"
import Caption from "../styled/caption" 
import StickySlide from "../../StickySlide"
import { DarkRelief } from "../../Relief"

const SeaWatch = () => {
  return (
    <DarkRelief hasTopMargin="true" hasBottomMargin="true" >
      <StickySlide>
        <Caption as="div" textAlign="center">In June, 2021, a plane belonging to the aid group Sea-Watch responded to distress signals from a migrant boat.</Caption>
      </StickySlide>
      <StickySlide
        stickyTop={
          <Video
            src="https://cdn.theoutlawocean.com/al-mabani/footage__seawatch-arrival.mp4"
            muted="muted"
            autoplay="autoplay"
            loop="loop"
            credit="Video courtesy Sea-Watch"
            maxWidth="var(--figure-max-width)"
          />
        }
      >
        <Caption as="div" textAlign="center">From the plane, Sea-Watch representatives filmed a Libyan Coast Guard ship trying to intercept the migrants.</Caption>
      </StickySlide>
      <StickySlide
        stickyTop={
          <Video
            src="https://cdn.theoutlawocean.com/al-mabani/footage__seawatch-shooting.mp4"
            muted="muted"
            hasSound="true"
            autoplay="autoplay"
            loop="loop"
            credit="Video courtesy Sea-Watch"
            maxWidth="var(--figure-max-width)"
            soundControl="right"
          />
        }
      >
        <Caption as="div" textAlign="center">The Coast Guard fired twice<br /> on the migrants.</Caption>
      </StickySlide>
      <StickySlide
        stickyTop={
          <Video
            src="https://cdn.theoutlawocean.com/al-mabani/footage__seawatch-ramming.mp4"
            muted="muted"
            autoplay="autoplay"
            loop="loop"
            credit="Video courtesy Sea-Watch"
            maxWidth="var(--figure-max-width)"
          />
        }
      >
        <Caption as="div" textAlign="center">The Coast Guard ship also attempted to ram their boat and snag its engine on a rope.</Caption>
      </StickySlide>
      <StickySlide>
        <Caption as="div" textAlign="center">After an hour-and-a-half-long chase, the Coast Guard turned back, and the migrants made it to Italy. (The Coast Guard did not respond to requests for comment.)</Caption>
      </StickySlide>
    </DarkRelief>
  );
};

export default SeaWatch;



